/**
 * Environment Variables Utility for nugle-link
 *
 * Uses DEV_MODE to switch between dev and prod API Gateway URLs.
 * Supports both environment variables and build-time configuration.
 */

// This function safely accesses environment variables
function getEnvVar(key: string, fallback: string = ''): string {
  // For React apps, environment variables must start with REACT_APP_
  // eslint-disable-next-line
  return process.env[key] || fallback
}

// Check if we're in development mode
// Can be controlled by REACT_APP_DEV_MODE env var or NODE_ENV
const DEV_MODE = getEnvVar('REACT_APP_DEV_MODE') === 'true' || getEnvVar('NODE_ENV') === 'development'

// API Configuration - switches between dev and prod
export const API_GATEWAY_URL = DEV_MODE
  ? 'https://kl1idqy5rh.execute-api.us-east-1.amazonaws.com/dev' // Dev URL
  : 'https://y096p0yrcj.execute-api.us-east-1.amazonaws.com/prod' // Prod URL

// Turnstile site key for bot protection
// Set via REACT_APP_TURNSTILE_SITE_KEY environment variable
export const TURNSTILE_SITE_KEY = '0x4AAAAAACJaHtbsBkF-VqqD'

// Environment info
export const isDevelopment = DEV_MODE
export const isProduction = !DEV_MODE

// Debug helper
export const getEnvInfo = () => ({
  isDevelopment,
  isProduction,
  devMode: DEV_MODE,
  apiUrl: API_GATEWAY_URL,
  nodeEnv: getEnvVar('NODE_ENV'),
  reactAppDevMode: getEnvVar('REACT_APP_DEV_MODE'),
})

// Validation helper
export const validateEnvVars = () => {
  if (!API_GATEWAY_URL) {
    throw new Error('API_GATEWAY_URL could not be determined')
  }
}

// Log current configuration (only in development)
if (DEV_MODE) {
  // eslint-disable-next-line
  console.log('🔧 nugle-link environment:', getEnvInfo())
}
